import script from "./userTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./userTransfer.vue?vue&type=script&setup=true&lang=js"

import "./userTransfer.vue?vue&type=style&index=0&id=69d79cc2&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d79cc2"]])

export default __exports__